import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { WebViewLink } from 'shared/routing/WebViewLinks';
import styled from 'styled-components';

const StyledLink = styled(WebViewLink)`
    fontSize: '14px',
    color: ${ColorDynamic.Blue500},
    textDecoration: 'none',`;

export function InstantTransferDescription() {
  return (
    <Box padding="small" backgroundColor="Silver200">
      <Stack space="xsmall">
        <Typography variant="h5">What is Instant Transfer?</Typography>
        <Typography>
          Instant Transfer is Super Dispatch’s beta payment feature that gives
          carriers immediate access to their money—right after a shipper sends
          payment—even on weekends and holidays. No more waiting the usual 3–5
          days.
        </Typography>
        <StyledLink
          target="_blank"
          rel="noopener noreferrer"
          href="https://support.superdispatch.com/hc/en-us/articles/42424487832595-Instant-Transfer-for-Faster-Carrier-Payments"
        >
          Learn more
        </StyledLink>
      </Stack>
    </Box>
  );
}
